import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { auditService, AuditHistoryList, IAuditRegularScheduleHistoryItem } from "../../../../entities/audit";
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import { useGlobalMessageActions } from "../../../../entities/globalMessage";
import { MyError } from "../../../../shared/lib/error/MyError";
import { AuthError } from "../../../../shared/lib/error/AuthError";
import { FEATURES, hasFeature, useMyActions } from "../../../../entities/my";
import { StudentDetailLayout } from "../detail/StudentDetailLayout";
import idmClasses from "../../../idm/ui/idm/idmWidget.module.scss";
import { useAppSelector } from "../../../../app/store/store";

export const StudentHistoryWidget: FC = () => {
    const {my} = useAppSelector(state => state.myReducer)
    const {id} = useParams<{id: string}>()
    const studentId = id && !Number.isNaN(Number(id)) ? Number(id) : 0
    const {setGlobalMessage} = useGlobalMessageActions()
    const {setIsAuth} = useMyActions()
    const [isLoading, setIsLoading] = useState(true)
    const [items, setItems] = useState<IAuditRegularScheduleHistoryItem[]>([])
    const canReadScheduleHistory = Boolean(studentId) && hasFeature(my, FEATURES.AUDIT.SCHEDULE_HISTORY_READ, studentId)

    useEffect(() => {
        if(!canReadScheduleHistory){
            setItems([])
            setIsLoading(false)
            return
        }

        let isActual = true

        const load = async () => {
            try{
                setIsLoading(true)
                const response = await auditService.listStudentRegularScheduleHistory(studentId)
                if(isActual){
                    setItems(response)
                }
            }
            catch(error){
                if(!isActual) return

                if(error instanceof AuthError){
                    setIsAuth(false)
                    setGlobalMessage({message: error.message, type: 'error'})
                    return
                }

                if(error instanceof MyError){
                    setGlobalMessage({message: error.message, type: 'error'})
                    return
                }

                setGlobalMessage({message: 'Ошибка при получении истории изменений студента', type: 'error'})
            }
            finally{
                if(isActual){
                    setIsLoading(false)
                }
            }
        }

        if(studentId){
            load()
        }

        return () => {
            isActual = false
        }
    }, [canReadScheduleHistory, setGlobalMessage, setIsAuth, studentId])

    if(!studentId){
        return null
    }

    return (
        <StudentDetailLayout
            studentId={studentId}
            selectedTab={2}
            showHistoryTab={canReadScheduleHistory}
            showWalletHistoryTab={canReadScheduleHistory}
        >
            {isLoading
                ? <section className={idmClasses.loader}><LoaderSpinner /></section>
                : canReadScheduleHistory
                    ? <section className={idmClasses.panel}>
                    <AuditHistoryList
                        items={items}
                        emptyText="История изменений графика студента пока пуста"
                    />
                </section>
                    : <section className={idmClasses.panel}>
                        <section className={idmClasses.placeholder}>История изменений недоступна</section>
                    </section>
            }
        </StudentDetailLayout>
    )
}
